import { useDateRanges } from '../../../shared/lib/hooks/UseDateRanges'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDetailedInfoFilter } from './types/DetailedInfoFilter.interface'
import { RootState } from '../../../app/store/Store'

export type TDetailedInfoTabs = 'Pages' | 'Affiliates'

type DetailedInfoState = {
  filters: IDetailedInfoFilter
  activeTab: TDetailedInfoTabs
  pagesExpanded: boolean
}

const dateRanges = useDateRanges()

const domainOverviewSlice = createSlice({
  name: 'detailedInfo',
  initialState: {
    filters: { dateRange: dateRanges.month, reversed_filters: '' },
    activeTab: 'Pages',
    pagesExpanded: false,
  } as DetailedInfoState,
  reducers: {
    setDetailedInfoFilter: (
      state: DetailedInfoState,
      action: PayloadAction<IDetailedInfoFilter>,
    ) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    setDetailedInfoActiveTab: (
      state: DetailedInfoState,
      { payload }: PayloadAction<TDetailedInfoTabs>,
    ) => {
      state.activeTab = payload
    },
  },
})

export const { setDetailedInfoFilter, setDetailedInfoActiveTab } = domainOverviewSlice.actions

export const selectDetailedInfoFilters = (state: RootState) => state.root.detailedInfo.filters

export const selectDetailedInfoActiveTab = (state: RootState) => state.root.detailedInfo.activeTab

export default domainOverviewSlice.reducer
